import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    color: Colors.Blue,
    fontWeight: FontWeight.Bold,
  },
  labelError: {
    color: Colors.Red,
  },
  error: {
    fontWeight: FontWeight.Regular,
    fontSize: 14,
  },
}));

export default useStyles;